<div class="container-fluid d-flex flex-fill flex-column gap-7">
    <div class="row">
        <div class="col-12 d-flex justify-content-between align-items-center px-0">
            <span class="heading-4 fw-semi-bold">Facebook</span>
        </div>
    </div>
    <div class="row">
        <div class="col-12 px-0">
            <span class="fs-7">Customise how your post will appear on Facebook.</span>
        </div>
    </div>
    <div class="row">
        <div class="col-12 col-md-7 d-flex flex-column gap-7 ps-0">
            <div class="d-flex flex-column gap-6">
                <pp-text-area id="fbPostTitle"
                    [form]="form"
                    placeholder="Title (optional)"
                    [rows]="2" />
                <pp-text-area id="fbPostDescription"
                    [form]="form"
                    placeholder="Description (required)"
                    [rows]="6" />
                <pp-checkbox [checked]="$safeNavigationMigration(form.get('fbIncludeOddrLink')?.value)"
                    id="fbIncludeOddrLink"
                    label="Include the ODDR verified link in the post description"
                    (checkChanged)="oddrLinkSelected($event)" />
            </div>
            <ng-container [ngTemplateOutlet]="mediaUploadPageSelection" />
        </div>
        <div class="col-12 col-md-5 mt-8 mt-md-0 d-flex justify-content-center justify-content-md-start">
            <pp-post-preview provider="facebook"
                [title]="$safeNavigationMigration(form.get('fbPostTitle')?.value)"
                [caption]="$safeNavigationMigration(form.get('fbPostDescription')?.value)"
                [includeOddrLink]="$safeNavigationMigration(form.get('fbIncludeOddrLink')?.value)"
                [oddrLink]="previewOddrLink"
                [thumbnailUrl]="previewThumbnailUrl"
                [mediaType]="previewMediaType"
                [imageCount]="previewImageCount" />
        </div>
    </div>
</div>
<div class="d-flex justify-content-between align-items-center mt-10">
    <ng-container *ngTemplateOutlet="uploadStatusIndicator" />
    <pp-button [disabled]="!form.valid"
        [shape]="buttonShape.Square"
        [variant]="buttonVariant.Primary"
        (buttonClick)="submitAndGoToNextStep()">Next</pp-button>
</div>

<ng-template #uploadStatusIndicator>
    @if (uploadProgress > 0 && !uploadComplete()) {
        <div class="upload-progress-inline d-flex align-items-center gap-6">
            <span class="fs-6 fw-semi-bold text-nowrap">Uploading... {{ uploadProgress }}%</span>
            <div class="upload-progress-bar-track">
                <div class="upload-progress-bar-fill" [style.width.%]="uploadProgress"></div>
            </div>
        </div>
    } @else if (uploadComplete() && !processingComplete()) {
        <div class="d-flex align-items-center gap-3">
            <span class="fs-6 fw-semi-bold text-nowrap">Processing...</span>
        </div>
    } @else if (processingComplete()) {
        <div class="d-flex align-items-center gap-3">
            <img alt="Ready" src="/assets/images/icons/check-circle-solid-primary.svg" height="24px" width="24px" />
            <span class="fs-6 fw-semi-bold text-nowrap">Ready</span>
        </div>
    } @else {
        <div></div>
    }
</ng-template>

<ng-template #mediaUploadPageSelection>
    <div class="card">
        <div class="card-body d-flex flex-column gap-7">
            <span class="fs-6 fw-semi-bold">Select Page</span>
            <span class="fs-6">Choose which Facebook Page to publish to.</span>
            @for (page of pages; track $index) {
                <pp-radio-button [checked]="form.get('fbPageSelection')?.value === page.id"
                    [id]="page.id"
                    [label]="page.name"
                    name="mediaUploadFbPageSelection"
                    [value]="page.id"
                    (optionChanged)="pageSelected($event)" />
            }
            @empty {
                <pp-alert [type]="alertType.Transparent" message="No Facebook Pages found. Make sure you have admin access to at least one Facebook Page." />
            }
        </div>
    </div>
</ng-template>
